import React, { useState } from 'react';
import StepWizard from 'react-step-wizard';
import { Row, Col, Button } from "reactstrap";
import cx from "classnames";
import Table from '../../../Table';
import CustomSwitch from '../../../Inputs/CustomSwitch';

import api from '@fortawesome/fontawesome';
import { expectedError } from '../../../Alerts/errors';

const WizNav = ({ data, currentStep, goToStep }) => {
    return (<Row className="mb-2">
        {data.map((_,index) => {
            return (<Col key={index} sm="2" md="2" lg="2" className="w-100 d-flex text-center mb-3">
            <Button style={{height: "80px"}} className={cx("m-auto header w-75 d-flex flex-column  text-center", {"fourth": currentStep === parseInt(index) + 1, "third": currentStep !== parseInt(index) + 1})} onClick={() => goToStep(parseInt(index) + 1)}>
                <span className="m-auto">{_.header}</span>
            </Button>
        </Col>)
        })}
    </Row>)
}

const ShortcutsSettings = ({menuItems, menuItemsShortcuts, onSubmit}) => {
    const [tmpMenuItemsS, setTmpMenuItemsS] = useState(menuItemsShortcuts);

    const _columns = [
        {
            Header: "MENIU",
            accessor: "label",
            Cell: cellInfo => <span className='w-100 text-center'>{cellInfo.value}</span>
        },
        {
            Header: "",
            filterable: false,
            accessor: "to",
            Cell: cellInfo => {
                const _index = tmpMenuItemsS.findIndex(_ => _["to"] === cellInfo.original.to);

                return <div className='w-100 text-center'>
                    <CustomSwitch onChange={(e) => handleChange(e, cellInfo.original)} className="m-auto" id={cellInfo.original.to} checked={_index === -1 ? false: true} />
                </div>
            },
            width: 100
        }
    ]

    const handleChange = (e, cellInfoOriginal) => {
        const { checked } = e.currentTarget;
        const _tmp = [...tmpMenuItemsS]


        if(checked){
            if(_tmp.length === 6){
                return expectedError(`Numarul maxim de scurtaturi este 6.`)
            }
            _tmp.push(cellInfoOriginal);
        } else{
            const _index = _tmp.findIndex(_ => _["to"] === cellInfoOriginal.to);
            _tmp.splice(_index, 1);
        } 
        
        setTmpMenuItemsS(_tmp);
    }

    return ( <div className='w-100 text-left'> 
        <h5 className='ft-1 pb-2 border-bottom'>SELECTEAZA MENIU PRINCIPAL</h5>
        <StepWizard nav={<WizNav data={menuItems} />}>
            {menuItems.map((_, index) => {
                const _content = [];

                for(const item of _["content"]){
                for(const menu of item["content"]){
                    _content.push(menu);
                }
                }

                return <div>
                    <h5 className='ft-1 pb-2 border-bottom'>SELECTEAZA MENIURI</h5>
                    <Table key={index} showPagination={false} className="scrollable" data={_content} columns={_columns} />
                </div>
            })}
        </StepWizard>
        <h5 className='ft-1 pb-2 border-bottom mt-2'>ACTIUNI</h5>
        <div className='w-100 d-flex flex-row-reverse'>
            <Button className="fourth" onClick={() => onSubmit(tmpMenuItemsS)}>SALVEAZA CONFIGURATIA</Button>
        </div>
    </div> );
}


 
export default ShortcutsSettings;